<template>
  <div class="rot-main">
    <Tabulator tableID="rotTable" :tableData="data['data']" tableTitle="ROTs" />
  </div>
</template>

<script>
/* eslint-disable */
import Tabulator from '@/components/Tabulator.vue';

export default {
  components: {
    Tabulator
  },
  props: {
    data: { type: Object, default: function() { return {} } },
  },
  methods: {
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.rot-main {
  height: 300px;
  max-height: 300px;
  min-height: 300px;
}
</style>